const GET_POST_SALE_DETAILS_BEGIN = 'header/account/GET_POST_SALE_DETAILS/BEGIN';
const GET_POST_SALE_DETAILS_SUCCESS = 'header/account/GET_POST_SALE_DETAILS/SUCCESS';
const GET_POST_SALE_DETAILS_FAILURE = 'header/account/GET_POST_SALE_DETAILS/FAILURE';

export {
  GET_POST_SALE_DETAILS_BEGIN,
  GET_POST_SALE_DETAILS_SUCCESS,
  GET_POST_SALE_DETAILS_FAILURE
};
